import {
  FilterType,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'
import { AnalyticsPageLocationsFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

const workspacesFilter = (
  source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>,
  locations: AnalyticsPageLocationsFragment[]
) => {
  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.workspace'),
    path: 'workspace',
    identifier: 'workspaceIds',
    type: FilterType.Integer,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: locations.map(({ name, id }) => ({
          label: name,
          value: id,
        })),
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: 'workspaceIds',
        value,
      })
    },
  })
}

export default workspacesFilter
